import type { ReactNode } from 'react';

type Props = {
  text: ReactNode;
  optional?: boolean;
};

export default function OptionalLabel({ text, optional = false }: Props) {
  if (!optional) return <>{text}</>;

  return (
    <>
      <span>{text}</span>{' '}
      <span className="optional-label-text">(optional)</span>
    </>
  );
}
